import { crudService, CrudServiceType } from "./crudService";
import { RestClient } from "./restClient";
import RestResponse from "@/models/client/RestResponse";
import RequestMethod from "@/models/client/RequestMethod";
import { SynonymGroup } from "@/models/synonym-group/synonymGroup";

export type SynonymGroupServiceType = CrudServiceType<SynonymGroup> & {
  getUserDictionary: () => RestResponse<SynonymGroup[]>;
  addSynonym: (groupId: string, synonym: string) => RestResponse<SynonymGroup>;
  removeSynonym: (
    groupId: string,
    synonym: string
  ) => RestResponse<SynonymGroup>;
  renameCanonicalTerm: (
    groupId: string,
    canonicalTerm: string
  ) => RestResponse<SynonymGroup>;
  activate: (
    groupId: string,
    activateGroup: boolean,
    synonym?: string
  ) => RestResponse<SynonymGroup>;
  deactivate: (
    groupId: string,
    deactivateGroup: boolean,
    synonym?: string
  ) => RestResponse<SynonymGroup>;
};

const synonymGroupServices = (
  client: RestClient,
  path: string
): SynonymGroupServiceType => ({
  ...crudService<SynonymGroup>(client, path),
  getUserDictionary: async () => {
    return await client.fetch<SynonymGroup[]>(
      RequestMethod.GET,
      `${path}/user/active-dictionary`
    );
  },
  addSynonym: async (groupId: string, synonym: string) => {
    return await client.fetch<SynonymGroup>(
      RequestMethod.POST,
      `${path}/${groupId}/add`,
      {
        synonymOriginal: synonym,
      }
    );
  },
  removeSynonym: async (groupId, synonym) => {
    return await client.fetch<SynonymGroup>(
      RequestMethod.POST,
      `${path}/${groupId}/remove`,
      {
        synonymNormalized: synonym,
      }
    );
  },
  renameCanonicalTerm: async (groupId, canonicalTerm) => {
    return await client.fetch<SynonymGroup>(
      RequestMethod.POST,
      `${path}/${groupId}/rename`,
      {
        canonicalTerm,
      }
    );
  },
  activate: async (groupId, activateGroup, synonym) => {
    return await client.fetch<SynonymGroup>(
      RequestMethod.POST,
      `${path}/${groupId}/activate`,
      {
        activateGroup,
        synonymNormalized: synonym,
      }
    );
  },
  deactivate: async (groupId, deactivateGroup, synonym) => {
    return await client.fetch<SynonymGroup>(
      RequestMethod.POST,
      `${path}/${groupId}/deactivate`,
      {
        deactivateGroup,
        synonymNormalized: synonym,
      }
    );
  },
});

export default synonymGroupServices;
